export const EXCMTASKTYPE_DELETE_RESET = 'EXCMTASKTYPE_DELETE_RESET'
export const EXCMTASKTYPE_DELETE_SET_ERROR = 'EXCMTASKTYPE_DELETE_SET_ERROR'
export const EXCMTASKTYPE_DELETE_SET_DELETED = 'EXCMTASKTYPE_DELETE_SET_DELETED'
export const EXCMTASKTYPE_DELETE_TOGGLE_LOADING = 'EXCMTASKTYPE_DELETE_TOGGLE_LOADING'
